<template>
  <div class="body">
      <Headtow></Headtow>
      <div id="w-center">
        <div id="Breadcrumb">
          <i class="el-icon-house Breadcrumb-i" ></i>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>{{info.datitle}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <!-- 左侧 -->
        <div class="w-products">
            <div id="content" v-loading="loading">
              <div v-html="info.content"></div>
            </div>
        </div>
        <!-- 左侧结束 -->
        <!-- 右侧开始 -->
         <div id="products-right">
             <p class="products-right-title">{{info.datitle}}</p>
             <ul class="products-right-ul" v-loading="loading">
               <li class="ov1" v-for="(item, index) in left" :key="item.id">
                 <a @click="getCont(item.id)">
                    {{item.title}}
                </a>
               </li>
             </ul>
         </div>
        <!-- 右侧结束 -->
      </div>
       <Foot></Foot>
  </div>

</template>

<script>
import headtow from '@/components/public/headtow.vue';
import foot from '@/components/public/foot.vue'
export default{
  data(){
    return {
      loading:true,
      info:[],
      left:[],
    }
  },
  components: {
    'Headtow': headtow,  //将别名demo 变成 组件 Demo
    'Foot': foot,
  },
  mounted(){
    this.id = this.$route.query.id;
    this.recordapi();
  },
  methods:{
    recordapi(){
        var that = this;
        that.$api.post("/Products/Aboutlx",{'id':that.id}).then(res => {
          console.log(res);
          that.info= res.info;
          that.left= res.left;
          that.loading = false
        });
    },
    getCont(id){
      this.loading = true
      this.id=id;
      this.recordapi();
    },
  }

 }
</script>



// WEBPACK FOOTER //
// src/components/Aboutgg.vue